import classnames from 'owa-classnames';
import {
    sclMultiLinePreviewStyles,
    twoLinePreviewStyles,
    oneLinePreviewStyles,
    noPreviewStyles,
} from 'owa-mail-listitem-styles/lib/scss/previewTextStyles.scss';

function getPreviewTextStyles(numMessagePreviewLines: number): string | undefined {
    let previewClass = '';
    if (numMessagePreviewLines === 2) {
        previewClass = twoLinePreviewStyles;
    } else if (numMessagePreviewLines === 1) {
        previewClass = oneLinePreviewStyles;
    } else {
        previewClass = noPreviewStyles;
    }
    // add MCL Path VSO:232980
    return classnames(previewClass, sclMultiLinePreviewStyles);
}
export default getPreviewTextStyles;
